import React, { useCallback, useEffect, useState } from 'react';
import { PDFQuestion } from '../../questions/PDFQuestion';
import { registerQuestionRenderer, type QuestionRendererComponent } from './registry';

const PdfRenderer: QuestionRendererComponent = ({
  question,
  existingResponse,
  onDraftChange,
  onHasUserInputChange,
  onValidityChange,
  onExtrasChange,
}) => {
  const questionId = question?.id ?? existingResponse?.question ?? -1;
  const [isValid, setIsValid] = useState<boolean>(Boolean(existingResponse));

  useEffect(() => {
    setIsValid(Boolean(existingResponse));
  }, [existingResponse, questionId]);

  useEffect(() => {
    const nextValid = isValid;
    onHasUserInputChange?.(nextValid);
    onValidityChange?.(nextValid);
    onExtrasChange?.({
      isPdfValid: nextValid,
    });

    if (questionId < 0) {
      onDraftChange(null);
      return;
    }

    if (nextValid) {
      onDraftChange(existingResponse ?? { question: questionId });
    } else {
      onDraftChange(null);
    }
  }, [
    existingResponse,
    isValid,
    onDraftChange,
    onExtrasChange,
    onHasUserInputChange,
    onValidityChange,
    questionId,
  ]);

  const handleValidationChange = useCallback((nextValid: boolean) => {
    setIsValid(nextValid);
  }, []);

  return (
    <PDFQuestion
      question={question}
      onValidationChange={handleValidationChange}
    />
  );
};

registerQuestionRenderer(['pdf'], PdfRenderer);
